import { ExpandLess, ExpandMore } from '@mui/icons-material';
import IconButton from 'components/IconButton';
import React from 'react';
import { Col, Collapse, Row } from 'reactstrap';

import { KPISectionStatus } from './helper';
import styles from './styles.module.css';

interface KPIChartGroupProps {
  actions?: React.ReactNode;
  children: React.ReactNode;
  groupId: string;
  isOpen: boolean;
  onToggle: () => void;
  status?: KPISectionStatus;
  title: string;
}

const KPIChartGroup = ({
  actions,
  children,
  groupId,
  isOpen,
  onToggle,
  status,
  title,
}: KPIChartGroupProps) => (
  <section className={styles.detailChartGroup}>
    <header className={styles.detailChartGroupHeader}>
      <Row className="align-items-center">
        <Col>
          <h4 className={styles.detailChartGroupTitle}>{title}</h4>
        </Col>
        <Col className={styles.detailChartGroupActions} xs="auto">
          {status && (
            <span
              aria-label={`Overall KPI status: ${status}`}
              className={`${styles.chartOverallStatus} ${
                styles[`chartOverallStatus${status.replace(' ', '')}`]
              }`}
              title={`Overall KPI status: ${status}`}
            />
          )}
          {isOpen && actions}
          <IconButton
            id={`${groupId}-toggle`}
            iconElement={
              isOpen ? (
                <ExpandLess fontSize="small" />
              ) : (
                <ExpandMore fontSize="small" />
              )
            }
            size="sm"
            tooltip={isOpen ? `Collapse ${title}` : `Expand ${title}`}
            onClick={onToggle}
          />
        </Col>
      </Row>
    </header>
    <Collapse isOpen={isOpen}>
      <div className={styles.detailChartGroupBody}>{children}</div>
    </Collapse>
  </section>
);

export default KPIChartGroup;
